export const AnalyticsEventAttribute = { 
    MainPhone: 'phone_main', 
    BranchPhone: 'phone_branch',
    AddToCart: 'add_to_cart',
};
